import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_TRANSACTION_FEE_UPSELL_CONFIGURATION = createFcmDetails(
	'transaction_fee_upsell_configuration',
	{
		owner: 'Monetization Squad',
		context: 'Membership Page',
		description: 'This FC controls the transaction fee upsell configuration on Membership page',
		import: false,
		template: {
			membership: {
				enabled: true,
				ratio: 0.035,
			},
		},
	},
);
